import type { Option } from '@openx/types/options.ts';
import type { FilterCriteria } from '../../types.ts';

export const getInitialMultiOptionWithRangeValues = (
  options?: Option[],
  appliedFilters?: FilterCriteria
): Record<string, boolean> => {
  return (
    options?.reduce<Record<string, boolean>>((acc, option) => {
      acc[option.id] = appliedFilters?.[option.id] !== undefined;

      return acc;
    }, {}) || {}
  );
};
